import { useState } from 'react'

import { Separator, DropdownMenu, DropdownMenuTrigger, DropdownMenuContent } from 'twyne-new.ui'

import { ActiveForm } from '@/components/form/ActiveSwitch';
import HeaderContainerForm from '@/components/headerContainer/Form';
import QuickActionsButton from '@/components/headerContainer/QuickActionsButton'
import { formatDateTime } from '@/utils';
import history from '@/utils/history';
import PageVariablesModal, { PageVariablesMenuItem } from 'components/modals/PageVariablesModal';

const pixelNotesTab = {
  value: 'notes',
  label: 'Pixel Notes',
  content: <div className='flex flex-col gap-4'>
    <p className='twy-text-base'>
      Leave Matching PID field blank to show pixel on all requests. Other criteria, such as slot position, will still apply.
    </p>
    <p className='twy-text-base'>
      Pixels of type HTTP POST will send data of media type application/x-www-form-urlencoded. Data entered as POST Data
      must be a JSON blob of key: value, where key is the form field name and value is the data to send.
    </p>
  </div>,
}

function PixelHeading({ data, active, onChangeActive }) {
  const [variablesOpen, setVariablesOpen] = useState(false)

  return <>
    <HeaderContainerForm
      title='Pixels'
      data={{ ...data, createdAt: formatDateTime(data?.created_at), updatedAt: formatDateTime(data?.updated_at) }}
      onCancel={() => history.goBack()}
      className='relative'
    >
      <ActiveForm active={active} onChangeActive={onChangeActive} />
      <Separator orientation='vertical' className='py-4' />
      <DropdownMenu optionsLabel='Options' modal={false}>
        <DropdownMenuTrigger className='flex items-center gap-1'>
          <QuickActionsButton />
        </DropdownMenuTrigger>
        <DropdownMenuContent align='start'>
          <PageVariablesMenuItem onSelect={() => setVariablesOpen(true)} />
        </DropdownMenuContent>
      </DropdownMenu>
    </HeaderContainerForm>
    <PageVariablesModal tabs={[pixelNotesTab]} open={variablesOpen} onOpenChange={setVariablesOpen} />
  </>
}

export default PixelHeading
